function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.164 11.969l6.398 6.398 2.121-2.121-6.398-6.399 6.726-6.725L16.889 1l-6.725 6.726L3.438 1 1.316 3.121l6.726 6.726-6.399 6.399 2.122 2.121 6.399-6.399z",
  fill: "#CCC"
});

var SvgBurgerMenuCross = function SvgBurgerMenuCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4xNjM1IDExLjk2ODVMMTYuNTYyMiAxOC4zNjcxTDE4LjY4MzUgMTYuMjQ1OEwxMi4yODQ5IDkuODQ3MTRMMTkuMDEwNSAzLjEyMTUxTDE2Ljg4OTIgMS4wMDAxOUwxMC4xNjM1IDcuNzI1ODJMMy40Mzc3MyAxTDEuMzE2NDEgMy4xMjEzMkw4LjA0MjIyIDkuODQ3MTRMMS42NDMzOSAxNi4yNDZMMy43NjQ3MSAxOC4zNjczTDEwLjE2MzUgMTEuOTY4NVoiIGZpbGw9IiNDQ0NDQ0MiLz4KPC9zdmc+Cg==";
export { SvgBurgerMenuCross as ReactComponent };